// Types
type EnvSetting = {
    BACKEND_API_URL: string;
    REMOTE_ENTRY_PLUGINS: Record<string, string | undefined>;
};

const envSettings = window as unknown as EnvSetting;

export default class Config {
    static BACKEND_API_URL = envSettings.BACKEND_API_URL;

    static REMOTE_ENTRY_PLUGINS = envSettings.REMOTE_ENTRY_PLUGINS || {};
}
